import http from "@/services/http";

export const contracts = () => {
  async function listByRental(idRental) {
    const {data} = await http.get('/contracts/byRental/'+idRental);
    return data;
  }

  async function generate(idRental) {
    const response = await http.post('/contracts/generate/'+idRental, {});
    return response.data;
  }

  async function cancel(id) {
    await http.put('/contracts/cancel/'+id, {});
    return true;
  }

  async function getTemplate() {
    const {data} = await http.get('/contracts/template');
    return data;
  }

  async function updateTemplate(template) {
    const response = await http.post('/contracts/template', { template });
    return response.data;
  }

  // Público (cliente assinando pelo link)
  async function getByToken(token) {
    const {data} = await http.get('/contract/'+encodeURIComponent(token));
    return data;
  }

  async function sign(token, dados) {
    const response = await http.post('/contract/'+encodeURIComponent(token)+'/sign', dados);
    return response.data;
  }

  return {listByRental, generate, cancel, getTemplate, updateTemplate, getByToken, sign};
}
